import util from '../util'

let controller = 'OperadorOnboardingAssociado'
export default Object.assign({}, util.GetCrud(controller, null), {
    AcessoUsuario: function (dto, options) {
        if (options && options.data) dto.data = options.data
        return util.Axios.GetAll(controller + "/AcessoUsuario", dto)
    },
    AtivarUsuario: function (id) {
        return util.Axios.Post(controller + `/${id}/Ativar`, {})
    },
    EnviarEmailPrimeiroAcesso: function (dto) {
        return util.Axios.Post(controller + "/PrimeiroAcesso", dto)
    }
})
